import React, { useState, useCallback } from 'react'
import Drawer from '@material-ui/core/Drawer'
import { captureEvent } from '../../utils/posthog'
import { POSTHOG_EVENTS } from '../../constants/posthog'
import {
  FaqLinkContainer,
  FaqLink,
  DrawerContainer,
  DrawerHeader,
  DrawerTitle,
  CloseButton,
  QuestionsContainer,
  QuestionItem,
  QuestionHeader,
  QuestionTitle,
  ExpandIcon,
  QuestionContent,
  QuestionText,
  FooterContainer,
  FooterText,
  FooterLink
} from './styles'

// FAQ específica para renegociação
const FAQ_QUESTIONS = [
  {
    id: 1,
    title: 'Como funciona a renegociação?',
    content:
      'A renegociação permite que você ajuste as condições do seu financiamento de acordo com sua realidade financeira atual. Você pode escolher entre pagar à vista com desconto ou parcelar o valor em novas condições.'
  },
  {
    id: 2,
    title: 'Qual o prazo para aceitar a proposta?',
    content:
      'A proposta tem validade limitada. Verifique a data de vencimento no resumo do acordo. Após o vencimento, será necessário solicitar uma nova simulação.'
  },
  {
    id: 3,
    title: 'Posso alterar o valor da entrada?',
    content:
      'Sim! Clique em "Escolher outro valor" na seção de entrada para definir um valor personalizado. O valor deve respeitar os limites mínimo e máximo informados.'
  },
  {
    id: 4,
    title: 'Como funciona o desconto?',
    content:
      'O desconto é aplicado automaticamente sobre o saldo devedor. Quanto maior o valor da entrada, maior pode ser o desconto obtido.'
  },
  {
    id: 5,
    title: 'Quando vence a primeira parcela?',
    content:
      'A data de vencimento da entrada e da primeira parcela são exibidas no resumo do acordo. Você pode visualizar todas as datas no detalhamento das parcelas.'
  },
  {
    id: 6,
    title: 'Preciso de avalista para renegociar?',
    content:
      'Depende da análise do seu contrato. Caso seja necessário, você e o avalista precisarão assinar o termo de renegociação digitalmente.'
  }
]

const FaqQuestion = ({ question, isOpen, onToggle }) => {
  return (
    <QuestionItem>
      <QuestionHeader onClick={onToggle} aria-expanded={isOpen} aria-controls={`faq-content-${question.id}`}>
        <QuestionTitle>{question.title}</QuestionTitle>
        <ExpandIcon isOpen={isOpen}>+</ExpandIcon>
      </QuestionHeader>
      <QuestionContent isOpen={isOpen} id={`faq-content-${question.id}`} aria-hidden={!isOpen}>
        <QuestionText>{question.content}</QuestionText>
      </QuestionContent>
    </QuestionItem>
  )
}

export const FaqDrawer = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [openQuestionId, setOpenQuestionId] = useState(null)

  const handleToggleDrawer = useCallback(() => {
    if (!isOpen) {
      captureEvent(POSTHOG_EVENTS.VIEW, {
        tela: 'renegociacao_faq',
        descricao: 'Visualizou a FAQ do processo de renegociação',
      })
    }
    setIsOpen(!isOpen)
  }, [isOpen])

  const handleCloseDrawer = useCallback(() => {
    setIsOpen(false)
  }, [])

  const handleToggleQuestion = questionId => {
    setOpenQuestionId(openQuestionId === questionId ? null : questionId)
  }

  return (
    <>
      <FaqLinkContainer>
        <FaqLink onClick={handleToggleDrawer} aria-label="Abrir FAQ" aria-expanded={isOpen}>
          Dúvidas? Acesse nossa FAQ
        </FaqLink>
      </FaqLinkContainer>

      <Drawer anchor="right" open={isOpen} onClose={handleCloseDrawer}>
        <DrawerContainer role="dialog" aria-labelledby="faq-drawer-title">
          <DrawerHeader>
            <DrawerTitle id="faq-drawer-title">FAQ</DrawerTitle>
            <CloseButton onClick={handleCloseDrawer} aria-label="Fechar FAQ">
              ×
            </CloseButton>
          </DrawerHeader>

          <QuestionsContainer>
            {FAQ_QUESTIONS.map(question => (
              <FaqQuestion
                key={question.id}
                question={question}
                isOpen={openQuestionId === question.id}
                onToggle={() => handleToggleQuestion(question.id)}
              />
            ))}
          </QuestionsContainer>

          <FooterContainer>
            <FooterText>
              Não encontrou o que procurava?{' '}
              <FooterLink href="/dashboard/ajuda" target="_blank" rel="noopener noreferrer">
                Clique aqui para acessar a nossa FAQ completa.
              </FooterLink>
            </FooterText>
          </FooterContainer>
        </DrawerContainer>
      </Drawer>
    </>
  )
}

export default FaqDrawer
